export const SET_ORGANIZATION = "SET_ORGANIZATION";
export const GET_ORGANIZATION = "GET_ORGANIZATION";
export const SET_LOGO_IMAGE = "SET_LOGO_IMAGE";
export const GET_LOGO_IMAGE = "GET_LOGO_IMAGE";
export const SET_BACKGROUND_IMAGE = "SET_BACKGROUND_IMAGE";
export const GET_BACKGROUND_IMAGE = "GET_BACKGROUND_IMAGE";
export const SET_ORGANIZATION_SLUG = "SET_ORGANIZATION_SLUG";
export const SET_RESPONSIBLE_USERS = "SET_RESPONSIBLE_USERS";
export const GET_RESPONSIBLE_USERS = "GET_RESPONSIBLE_USERS";
export const SET_FEEDBACK_ASSIGNEE = "SET_FEEDBACK_ASSIGNEE";
export const ADD_DIVISIONS = "ADD_DIVISIONS";
